import React, { Component, Fragment } from 'react';
import MetaTags from 'react-meta-tags';
// import Header from '../layouts/Header';
import Headertwo from '../layouts/Headertwo';
// import Footer from '../layouts/Footer';
import Footertwo from '../layouts/Footertwo';
import Content from '../sections/home/Content';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: 'J.W. Oliver - Do Hard Stuff',
            description: 'Do Hard Stuff...',
            ogUrl: 'https://www.jwoliver.com/',
            ogType: 'website',
            ogTitle: 'J.W. Oliver',
            ogDescription: 'Do Hard Stuff...',
            ogImage: '',
            twitterCard: 'summary_large_image',
            twitterDomain: 'jwoliver.com',
            twitterUrl: 'https://www.jwoliver.com/',
            twitterTitle: 'J.W. Oliver',
            twitterDescription: 'Do Hard Stuff...',
            twitterImage: ''
        };
    }

    componentDidMount() {
        // code to fetch the meta data for a specific blog and update the state accordingly
    }

    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>{this.state.title}</title>
                    <meta name="description" content={this.state.description} />
                    <meta property="og:url" content={this.state.ogUrl} />
                    <meta property="og:type" content={this.state.ogType} />
                    <meta property="og:title" content={this.state.ogTitle} />
                    <meta property="og:description" content={this.state.ogDescription} />
                    <meta property="og:image" content={this.state.ogImage} />
                    <meta name="twitter:card" content={this.state.twitterCard} />
                    <meta property="twitter:domain" content={this.state.twitterDomain} />
                    <meta property="twitter:url" content={this.state.twitterUrl} />
                    <meta name="twitter:title" content={this.state.twitterTitle} />
                    <meta name="twitter:description" content={this.state.twitterDescription} />
                    <meta name="twitter:image" content={this.state.twitterImage} />
                </MetaTags>
                <Headertwo />
                <Content />
                <Footertwo />
            </Fragment>
        );
    }
}

export default Home;
